"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelSVGDraw = exports.LABEL_SIZE = void 0;
var tslib_1 = require("tslib");
var model_1 = require("../../model");
var unit_1 = require("../../unit");
var mithril_1 = require("../mithril");
var theme_1 = require("../theme");
var util_draw_svg_1 = require("./util.draw.svg");
function getComputedTextLengthSafe(textEl) {
    try {
        return textEl.getComputedTextLength();
    }
    catch (e) {
        return 0;
    }
}
var LABEL_ACCEPT_AND_DELETE_RADIUS = 8;
var DEFAULT_CHAR_WIDTH = 6;
var ELEMENT_NODE = 1;
/** Line length to verify that it is not too long, in characters */
var ELLIPSIS_LINE_LENGTH = 25;
/** Length of a line that will have to be ...'d  */
var ELLIPSIS_LINE_MAX_LENGTH = 35;
var Style = (_a = {},
    _a[theme_1.ClassNames.label.text] = {
        'font-size': theme_1.StyleConfig.FONT_SIZE + 'px',
        'user-select': 'none',
        'pointer-events': 'none'
    },
    _a[theme_1.ClassNames.label.rect.container] = {
        fill: theme_1.StyleConfig.LABEL.FILL,
        stroke: 'none',
        'stroke-width': 0
    },
    _a[theme_1.ClassNames.label.rect.isHighlighted] = {
        fill: theme_1.StyleConfig.LABEL.FILL_HIGHLIGHTED
    },
    _a);
exports.LABEL_SIZE = {
    height: 5,
    width: 210
};
var LabelSVGDraw = /** @class */ (function () {
    function LabelSVGDraw() {
    }
    LabelSVGDraw.view = function (node, options) {
        var _a, _b;
        var currentState = node.state;
        var children = [];
        var parent = node.parent;
        var nodeId = currentState.id;
        var labelHeight = LabelSVGDraw.height(1);
        var isParentSelected = false;
        var isDeleteShown = false;
        var isAcceptShown = false;
        var spanColors = null;
        if (parent != null && model_1.CollectionModelDrawableMarker.isMarker(parent)) {
            var text = options.draw.getLabelText(parent.id, options);
            spanColors = options.useColorCoding ? options.draw.getSpanColors(parent.id) : null;
            labelHeight = LabelSVGDraw.height(text.length);
            children.push(LabelSVGDraw.textLines(node, options, text));
            nodeId = parent.state.id;
            // if the detection class is zero offset, show the base selection text
            // if the detection class is an offset class other than zero_offset, show the base offset selection text
            // if its neither then leave it as null
            var baseSelectionText = ((_a = parent.insight) === null || _a === void 0 ? void 0 : _a.detection_class) === 'zero_offset' ? 'Select to Set Base' : model_1.insightOffsetClassDetections.includes(((_b = parent.insight) === null || _b === void 0 ? void 0 : _b.detection_class) || '') ? 'Select to Set Base Offset' : null;
            if (baseSelectionText && !parent.collectionHasBase) {
                children.push(LabelSVGDraw.textLines(node, options, [baseSelectionText]));
            }
            if (model_1.CollectionModelDrawableMarker.isBase(parent) && parent.isInsightMeasurement) {
                isAcceptShown = options.isInteractive &&
                    options.isEditable &&
                    options.draw.state.tool == null &&
                    !!options.isInsightMarkersVisible &&
                    node.isInsightMeasurement;
            }
            else {
                isDeleteShown = options.isInteractive &&
                    options.isEditable &&
                    parent.isDeletable &&
                    options.draw.state.tool == null;
                isAcceptShown = isDeleteShown && !!options.isInsightMarkersVisible && node.isInsightMeasurement;
            }
        }
        else if (parent != null && model_1.CollectionModelDrawableLine.isLine(parent)) {
            nodeId = parent.state.id;
            var text = options.draw.getLabelText(parent.id, options);
            labelHeight = LabelSVGDraw.height(text.length);
            var selectedId = options.draw.state.selectedId;
            isParentSelected = selectedId === nodeId ||
                selectedId === parent.start.id ||
                selectedId === parent.end.id;
            children.push(LabelSVGDraw.textLines(node, options, text));
            isDeleteShown = options.isInteractive &&
                options.isEditable &&
                parent.isDeletable &&
                options.draw.state.tool == null;
            isAcceptShown = isDeleteShown && !!options.isInsightMarkersVisible && node.isInsightMeasurement;
        }
        else {
            children.push(LabelSVGDraw.textLines(node, options, node.text));
        }
        var isSelected = options.draw.state.selectedId === nodeId || isParentSelected;
        var isHighlighted = options.draw.state.hoverId === nodeId;
        if (isDeleteShown && (isSelected || isHighlighted)) {
            children.push(LabelSVGDraw.deleteButton(options));
        }
        if (isAcceptShown && (isSelected || isHighlighted)) {
            children.push(LabelSVGDraw.acceptButton(options));
        }
        var classNames = [
            theme_1.ClassNames.label.container,
            isSelected ? theme_1.ClassNames.isSelected : null
        ].join(' ');
        var rectClassNames = [
            theme_1.ClassNames.label.rect.container,
            isSelected ? theme_1.ClassNames.label.rect.isSelected : null,
            isHighlighted ? theme_1.ClassNames.label.rect.isHighlighted : null,
            options.isInteractive ? theme_1.ClassNames.isMoveable : null
        ].join(' ');
        var fill = theme_1.StyleConfig.LABEL.FILL;
        if (options.isInsightMarkersVisible && node.isInsightMeasurement) {
            fill = theme_1.StyleConfig.LABEL.FILL_INSIGHT;
        }
        else if (isHighlighted) {
            fill = theme_1.StyleConfig.LABEL.FILL_HIGHLIGHTED;
        }
        else if (isSelected) {
            fill = theme_1.StyleConfig.LABEL.FILL_SELECTED;
        }
        if (spanColors) {
            children.push(LabelSVGDraw.rectSpansColors(spanColors, labelHeight, isHighlighted, options));
        }
        var width = options.scale * exports.LABEL_SIZE.width;
        var height = options.scale * labelHeight;
        var rect = (0, mithril_1.m)('rect', {
            className: rectClassNames,
            x: '0',
            y: '0',
            width: width,
            height: height,
            fill: fill,
            'fill-opacity': isHighlighted ? 0.9 : 0.75,
            'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.LABEL,
            'c-Draw-draggable': 'true'
        });
        return (0, mithril_1.m)('g', {
            // key: currentState.id,
            className: classNames,
            transform: "translate(".concat(node.state.x, ", ").concat(node.state.y, ")"),
            'c-Draw-node-id': nodeId,
            'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.LABEL
        }, tslib_1.__spreadArray([rect], children, true));
    };
    LabelSVGDraw.rectSpansColors = function (spanColors, labelHeight, isHighlighted, options) {
        var width = options.scale * exports.LABEL_SIZE.width;
        var height = options.scale * labelHeight;
        var colorRects = [];
        spanColors.forEach(function (color, index) {
            var colorRect = (0, mithril_1.m)('rect', {
                x: (width * 0.015 * index),
                y: '0',
                width: width * 0.015,
                height: height,
                fill: color,
                'fill-opacity': isHighlighted ? 1 : 0.85
            });
            colorRects.push(colorRect);
        });
        return colorRects;
    };
    LabelSVGDraw.verticalSeparation = function (node, options, firstMarkerPoint, secondMarkerPoint, title, index, clearanceInMeters) {
        var children = [];
        var separationDistanceMeters = options.draw.drawState.collection.state
            .getGeometry(options.draw.capture.objectId)
            .calculateDistance(secondMarkerPoint, firstMarkerPoint);
        var labelWidth = exports.LABEL_SIZE.width;
        var labelHeight = LabelSVGDraw.height(1);
        var indexOffset = index * theme_1.StyleConfig.STROKE_WIDTH * 4;
        var distanceBetweenMarkers = Math.abs(firstMarkerPoint.y - secondMarkerPoint.y);
        var value = unit_1.IkeUnit.display(separationDistanceMeters, options.units === 'meters' ? unit_1.IkeUnit.CENTIMETER : unit_1.IkeUnit.INCH, null, null, 0);
        var displaySpace = Math.round(unit_1.IkeUnit.convert(separationDistanceMeters, options.units === 'meters' ? unit_1.IkeUnit.CENTIMETER : unit_1.IkeUnit.INCH, unit_1.IkeUnit.METER));
        var displayClearance = clearanceInMeters ? Math.round(unit_1.IkeUnit.convert(clearanceInMeters, options.units === 'meters' ? unit_1.IkeUnit.CENTIMETER : unit_1.IkeUnit.INCH, unit_1.IkeUnit.METER)) : null;
        var isInClearance = displayClearance && Math.abs(displaySpace) >= displayClearance;
        var displayAsInsight = options.isInsightMarkersVisible && node.isInsightMeasurement;
        var text = displayClearance ? (isInClearance ? '✅ ' : '❌ ') + value + ' - ' + title : value + ' - ' + title;
        var textLine = (0, mithril_1.m)('text', {
            className: theme_1.ClassNames.label.text,
            style: Style[theme_1.ClassNames.label.text],
            y: '0.3em',
            x: "0.3em",
            width: labelWidth,
            'text-anchor': 'start'
        }, text);
        var fill = displayAsInsight ? theme_1.StyleConfig.LABEL.FILL_INSIGHT : theme_1.StyleConfig.LABEL.FILL;
        var rect = (0, mithril_1.m)('rect', {
            x: -theme_1.StyleConfig.STROKE_WIDTH / 2,
            y: -labelHeight / 2,
            width: labelWidth,
            height: labelHeight,
            fill: fill,
            'fill-opacity': 0.75,
            stroke: displayClearance ? isInClearance ? 'lime' : 'red' : 'none',
            'stroke-width': theme_1.StyleConfig.STROKE_WIDTH
        });
        var separationLineHeight = (distanceBetweenMarkers + theme_1.StyleConfig.STROKE_WIDTH) / options.scale;
        children.push(util_draw_svg_1.SVGUtil.DrawLineBordered({ x: labelWidth, y: -separationLineHeight / 2 }, { x: labelWidth, y: separationLineHeight / 2 }, 1, displayClearance ? isInClearance ? 'lime' : 'red' : theme_1.StyleConfig.STROKE_SECONDARY));
        children.push(rect);
        children.push(textLine);
        return (0, mithril_1.m)('g', {
            id: "vertical-separation".concat(node.id),
            transform: "translate(".concat(firstMarkerPoint.x - (labelWidth * options.scale) - options.draw.state.markerOffsetWidth + indexOffset, ", ").concat((firstMarkerPoint.y + secondMarkerPoint.y) / 2, ")scale(").concat(options.scale, ")")
        }, children);
    };
    LabelSVGDraw.height = function (lineCount) {
        return exports.LABEL_SIZE.height +
            (theme_1.StyleConfig.FONT_SIZE + 0.25 * theme_1.StyleConfig.FONT_SIZE) * (lineCount || 1);
    };
    LabelSVGDraw.textLines = function (node, options, lines) {
        var longestLine = 0;
        var output = [];
        for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            var text = LabelSVGDraw.text(node, options, line, i);
            text.attrs.y = (1 + i * 1.25) + 'em';
            longestLine = Math.max(longestLine, line.length);
            output.push(text);
        }
        var displayAsInsight = options.isInsightMarkersVisible && node.isInsightMeasurement;
        var xOffset = exports.LABEL_SIZE.width * options.scale / 2;
        var attrs = {
            transform: "translate(".concat(xOffset, ", ").concat(-6 * options.scale / 4, ")scale(").concat(options.scale, ")"),
            fill: options.isInsightMarkersVisible && displayAsInsight ? theme_1.StyleConfig.FONT_COLOR_INSIGHT : theme_1.StyleConfig.FONT_COLOR
        };
        if (options.isInteractive && longestLine > ELLIPSIS_LINE_LENGTH) {
            var ellipsisText = function (el) { return LabelSVGDraw.ellipsisText(el); };
            attrs['oncreate'] = ellipsisText;
            attrs['onupdate'] = ellipsisText;
        }
        return (0, mithril_1.m)('g', attrs, output);
    };
    LabelSVGDraw.text = function (node, options, line, offset) {
        var outputLine = line;
        if (options.isInteractive === false && outputLine.length * DEFAULT_CHAR_WIDTH > exports.LABEL_SIZE.width) {
            var newTextLen = exports.LABEL_SIZE.width / DEFAULT_CHAR_WIDTH;
            outputLine = line.substr(0, newTextLen) + '…';
        }
        return (0, mithril_1.m)('text', {
            className: theme_1.ClassNames.label.text,
            style: Style[theme_1.ClassNames.label.text],
            y: '1em',
            x: "0",
            width: options.scale * exports.LABEL_SIZE.width,
            'text-anchor': 'middle',
            dy: '0.25em',
            'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.LABEL,
            key: offset
        }, outputLine);
    };
    LabelSVGDraw.ellipsisText = function (_a) {
        var dom = _a.dom;
        var parentWidth = exports.LABEL_SIZE.width * 0.9;
        for (var i = 0; i < dom.childNodes.length; i++) {
            var textEl = dom.childNodes[i];
            if (textEl.nodeType !== ELEMENT_NODE) {
                continue;
            }
            var textNode = textEl.firstChild;
            if (textNode == null) {
                continue;
            }
            // Skip short lines
            if (textNode.textContent.length < ELLIPSIS_LINE_LENGTH) {
                continue;
            }
            // Skip text that has already been processed
            if (textNode.textContent.indexOf('…') > -1) {
                continue;
            }
            if (textNode.$lastText === textNode.textContent) {
                continue;
            }
            var computedLength = getComputedTextLengthSafe(textEl) || DEFAULT_CHAR_WIDTH * textNode.textContent.length;
            var addDots = computedLength > parentWidth;
            // If text lines are really long, just assume we will need to truncate it
            if (textNode.textContent.length > ELLIPSIS_LINE_MAX_LENGTH) {
                var textSizePerCharacter = computedLength / textNode.textContent.length;
                var maxNumberOfChars = Math.floor(parentWidth / textSizePerCharacter);
                textNode.textContent = textNode.textContent.slice(0, maxNumberOfChars);
            }
            while (computedLength > parentWidth) {
                textNode.textContent = textNode.textContent.slice(0, textNode.textContent.length - 2);
                computedLength = getComputedTextLengthSafe(textEl) || DEFAULT_CHAR_WIDTH * textNode.textContent.length;
            }
            if (addDots && textNode.textContent.indexOf('…') === -1) {
                textNode.textContent = textNode.textContent + '…';
            }
            else {
                textNode.$lastText = textNode.textContent;
            }
        }
    };
    LabelSVGDraw.deleteButton = function (options) {
        var radius = options.scale * LABEL_ACCEPT_AND_DELETE_RADIUS;
        var XSize = radius / 2;
        var y = radius * 1.25;
        var x = options.scale * exports.LABEL_SIZE.width - radius * 1.25;
        var strokeWidth = options.scale * theme_1.StyleConfig.STROKE_WIDTH;
        var X1 = (0, mithril_1.m)('line', {
            x1: x - XSize,
            y1: y - XSize,
            x2: x + XSize,
            y2: y + XSize,
            stroke: theme_1.StyleConfig.BUTTON.DELETE_STROKE,
            'stroke-width': strokeWidth,
            'pointer-events': 'none'
        });
        var X2 = (0, mithril_1.m)('line', {
            x1: x + XSize,
            y1: y - XSize,
            x2: x - XSize,
            y2: y + XSize,
            stroke: theme_1.StyleConfig.BUTTON.DELETE_STROKE,
            'stroke-width': strokeWidth,
            'pointer-events': 'none'
        });
        var circle = (0, mithril_1.m)('circle', {
            cx: x,
            cy: y,
            r: radius,
            fill: '#fafafa',
            'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.DELETE
        });
        return (0, mithril_1.m)('g', {
            className: theme_1.ClassNames.label.delete,
            transform: "translate(".concat(-8 * options.scale / 4, ", ").concat(5 * options.scale / 4, ")")
        }, [circle, X1, X2]);
    };
    LabelSVGDraw.acceptButton = function (options) {
        var radius = options.scale * LABEL_ACCEPT_AND_DELETE_RADIUS;
        var checkSymbolSize = radius / 2;
        var y = radius * 1.25;
        var x = radius * 1.25;
        var strokeWidth = options.scale * theme_1.StyleConfig.STROKE_WIDTH;
        var shortStroke = (0, mithril_1.m)('line', {
            x1: x - checkSymbolSize,
            y1: y,
            x2: x - (checkSymbolSize * 0.5) + (strokeWidth * 0.5),
            y2: y + (checkSymbolSize * 0.75),
            stroke: theme_1.StyleConfig.BUTTON.ACCEPT_STROKE,
            'stroke-width': strokeWidth,
            'pointer-events': 'none'
        });
        var longStroke = (0, mithril_1.m)('line', {
            x1: x - (checkSymbolSize * 0.5),
            y1: y + (checkSymbolSize * 0.75),
            x2: x + checkSymbolSize,
            y2: y - checkSymbolSize,
            stroke: theme_1.StyleConfig.BUTTON.ACCEPT_STROKE,
            'stroke-width': strokeWidth,
            'pointer-events': 'none'
        });
        var circle = (0, mithril_1.m)('circle', {
            cx: x,
            cy: y,
            r: radius,
            fill: '#fafafa',
            'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.ACCEPT
        });
        return (0, mithril_1.m)('g', {
            className: theme_1.ClassNames.label.accept,
            transform: "translate(".concat(8 * options.scale / 4, ", ").concat(5 * options.scale / 4, ")")
        }, [circle, shortStroke, longStroke]);
    };
    LabelSVGDraw.Size = exports.LABEL_SIZE;
    return LabelSVGDraw;
}());
exports.LabelSVGDraw = LabelSVGDraw;
//# sourceMappingURL=label.draw.svg.js.map